import { MinimalLayout } from '../components/templates/MinimalLayout.js';
import { Typography } from '../components/atoms/Typography.js';

export function TermsPage() {
  return (
    <MinimalLayout>
      <div className="space-y-6">
        <Typography variant="h2">利用規約</Typography>
        <Typography variant="caption">最終更新日: 2025年1月1日</Typography>

        <section className="space-y-2">
          <Typography variant="h4">第1条（適用）</Typography>
          <Typography variant="body-sm">
            本規約は、PulseAgent（以下「本サービス」）の利用に関する条件を定めるものです。
            ユーザーは、本サービスを利用することにより、本規約に同意したものとみなします。
          </Typography>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">第2条（サービスの内容）</Typography>
          <Typography variant="body-sm">
            本サービスは、AIを活用したインタビュー・サーベイの実施、
            回答の分析、およびレポートの生成を提供するサービスです。
          </Typography>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">第3条（利用条件）</Typography>
          <Typography variant="body-sm">
            ユーザーは、以下の条件を遵守して本サービスを利用するものとします。
          </Typography>
          <ul className="list-disc pl-6 text-sm text-neutral-600 space-y-1">
            <li>法令および公序良俗に反する行為を行わないこと</li>
            <li>他のユーザーの権利を侵害しないこと</li>
            <li>サービスの運営を妨害する行為を行わないこと</li>
            <li>虚偽の情報を提供しないこと</li>
          </ul>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">第4条（知的財産権）</Typography>
          <Typography variant="body-sm">
            本サービスに関する知的財産権は、運営者または権利者に帰属します。
            ユーザーは、サーベイ結果およびレポートを自己の業務目的で利用することができます。
          </Typography>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">第5条（免責事項）</Typography>
          <Typography variant="body-sm">
            本サービスは現状のまま提供されます。運営者は、本サービスの正確性、
            完全性、有用性について保証するものではありません。
            本サービスの利用により生じた損害について、運営者は一切の責任を負いません。
          </Typography>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">第6条（サービスの変更・停止）</Typography>
          <Typography variant="body-sm">
            運営者は、事前の通知なく本サービスの内容を変更、 または提供を停止することがあります。
          </Typography>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">第7条（規約の変更）</Typography>
          <Typography variant="body-sm">
            運営者は、必要に応じて本規約を変更することがあります。
            変更後の規約は、本サービス上に掲載した時点で効力を生じるものとします。
          </Typography>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">第8条（準拠法・管轄）</Typography>
          <Typography variant="body-sm">
            本規約は日本法に準拠し、本サービスに関する紛争については、
            東京地方裁判所を第一審の専属的合意管轄裁判所とします。
          </Typography>
        </section>
      </div>
    </MinimalLayout>
  );
}
